import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { DateTimeUtility } from '@shared/utility/DateTime.Utility';
import { DateTimeNonMomentUtility } from '@shared/utility/DateTimeNonMoment.Utility';

export interface IIpConnectionModel extends IRestModel {
    address: string;
    port: string;
}

export class IpConnectionModel extends BaseModel implements IIpConnectionModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;
    public address: string = null;
    public port: string = null;
    public lastUsed: Date = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-IpConnectionModel');

        this.lastUsed = DateTimeNonMomentUtility.fromRestApiDateTime(this.lastUsed);
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
            LastUsed: DateTimeNonMomentUtility.toRestApiDateTime(this.lastUsed),
        };
    }
}
